export const enum ModalTypes {
  CONFIRMATION = "Confirmation-Modal",
  WORKSPACE_CREATION = "Workspace-Creation-Modal",
  PROJECT_CREATION = "Project-Creation-Modal",
  ANALYSIS_CREATION = "Analysis-Creation-Modal",
  INFO = "Info-Modal",
  ADD_NEW_DATASET = "Add-New-Dataset-Modal",
  DELETE_IO_RECORD = "Delete-Io-Record-Modal",
  IORECORD_ERRORS = "Io-Record-Errors-Modal",
  MOVE_ANALYSIS = "Move-Analysis-Modal",
  MOVE_PROJECT = "Move-Project-Modal",
  // Workflow Modals
  WORKFLOW_ERRORS = "Workflow-Errors-Modal",
  PROFILE = "Profile-Modal",
  EDIT_FLOW_DETAILS = "Edit-Flow-Details-Modal",
  UPLOAD_FLOW = "Upload-Flow-Modal",
  MARK_AS_OUTPUT = "Mark-As-Output-Modal",
  FLOW_PREVIEW = "Flow-Preview-Modal",
  FLOW_DETAILS = "Flow-Details-Modal",
  RENAME_NODE = "Rename-Node-Modal",
  CONFIRM_TERMINATE = "Confirm-Terminate-Modal",
  DELETE_NODE = "Delete-Node-Modal",
  CONFIRM_NODE_EDIT = "Confirm-Node-Edit-Modal",
  RUN_ERRORS = "Run-Errors-Modal",
  DELETE_EDGE = "Delete-Edge-Modal",
  WF_CONFIRMATION = "Wf-Confirmation-Modal",
  RENAME_VERSION = "Rename-Version-Modal",
  // usermanager modals
  MANAGE_ACCESS = "Manage-Access-Modal",
  INVITE_USERS = "Invite-Users-Modal",
  ADD_ADMIN = "Add-Admin-Modal",
  REMOVE_ADMIN = "Remove-Admin-Modal",
  REMOVE_ORG_USER = "Remove-Org-User-Modal",
  WARNING_ADMIN = "Warning-Admin-Modal",
  REMOVE_USER_ACCESS = "remove-user-access",
  INVITE_MEMBER_MANAGE_ACCESS = "Invite-Member-Manage-Access-Modal",
  LEAVE_ORG = "Leave-Org-Modal",
  DELETE_ACCOUNT = "Delete-Account-Modal",
  DELETE_OTP = "Delete-Otp-Modal",

  //EDA modals
  EXPLORE_DATASET = "Explore-Dataset-Modal",
  TERMINATE_EXECUTION = "Terminate-Execution-Modal",
  CLOSE_EDA = "Close-EDA-Modal",
  FATAL_ERROR = "Fatal-Error-Modal",
  EDA_SESSION_TIMEOUT_WARNING = "Session-Timeout-Warning-Modal",
  EDA_SESSION_ENDED = "Session-Ended-Modal",

  //LLM Modals
  LLM_ERRORS = "LLM-Errors-Modal",
  FULL_DATA = "Full-Data-Modal",
  SAVE_STEPS = "Save-Steps-Modal",
  DELETE_STEP = "Delete-Step-Modal",
  ERROR_STEPS_WARNING = "Error-Steps-Warning-Modal",
  EXECUTION_REQUIRED = "Execution-Required-Modal",
  EXPANDED_PROMPT = "Expanded-Prompt-Modal",

  //DATA Manager
  EXPORT_DATASET = "Export-Dataset-Modal",
  CANCEL_UPLOAD = "Cancel-Upload-Modal",
  SELECT_SHEET = "Select-Sheet-Modal",
  DOWNLOAD_DATA = "Download-Data-Modal",
  DATASET_NAME = "Dataset-Name-Modal",
  DISCARD_DATASET = "Discard-Dataset-Modal",
  USAGE_CONFIRMATION = "Usage-Confirmation-Modal",
  EDIT_DATASET_DETAILS = "Edit-Dataset-Details-Modal",
  EXPORT_CONNECTORS = "Export-Connectors-Modal",
  EXPORT_ERROR = "Export-Error-Modal",
  CANCEL_EXPORT = "Cancel-Export-Modal",
  DELETE_ACTOR = "Delete-Actor-Modal",

  // Timeout Modals
  TIMEOUT_WARNING = "Timeout-Warning-Modal",
  TIMED_OUT = "Timed-Out-Modal",
  FEEDBACK = "FEEDBACK",
  UNLOCK_APP = "Unlock-App-Modal",
}
